<template>
  <div class="header-search-trust">
    <div
      class="header-search low-header-xl"
    >
      <div class="bg">
        <hero-image
          :img-src="backgroundImage"
          :alt="bgImageAltText"
          :extra-class="'hero-image'"
          :default-dimension="'400x235'"
        />
      </div>
      <!-- EDVUE-516 hint from michael: ;background-position:center bottom not works for every image; to be discussed -->
      <div class="content">
        <div class="row">
          <div class="col-xl-10 mx-auto">
            <div
              class="multiHeadline d-flex"
              :class="{claimontop:claimtop }"
            >
              <h1
                v-if="headerSearchSubtitle && multiHeadline"
                v-dompurify-html="headerSearchSubtitle"
                class="subtitle"
                :class="subTitleClass"
              />
              <div
                v-if="headerSearchTitleHtml && multiHeadline"
                v-dompurify-html="headerSearchTitleHtml"
                :class="claimClass"
              />
            </div>
            <h1
              v-if="headerSearchTitle && !multiHeadline"
              class="h2"
            >
              {{ headerSearchTitle }}
            </h1>

            <h1
              v-if="headerSearchSubtitle && !multiHeadline"
              v-dompurify-html="headerSearchSubtitle"
              class="h2"
            />

            <header-search-form
              :only-fill-store="onlyFillStore"
              :multi-headline="multiHeadline"
              :input-col-width="12"
              :header-search-query="headerSearchQuery"
            />
          </div>
        </div>
      </div>
    </div>
    <trust-elements v-if="!hideTrustElements" />
  </div>
</template>

<script>
import TrustElements from 'components/TrustElements.vue';
import { mapGetters, mapMutations } from 'vuex';
import HeaderSearchForm from 'components/search/HeaderSearchForm.vue';
/* ICONS */
// import IconFaShieldAlt from 'icons/fa/light/shield-alt.svg';

// import devicehelper to get breakpoint information
import DeviceHelper from 'mixins/DeviceHelper';
import HeroImage from 'components/HeroImage.vue';
import config from 'config/appConfig';
// import {
//   backgroundImages,
//   backgroundImagesCountry,
//   backgroundImagesPath,
//   backgroundImagesRegion,
// } from 'config/heroImages';

export default {
  name: 'HeaderSearch',
  i18nOptions: { namespaces: ['common', 'flatpickr', 'search'] },
  components: {
    TrustElements,
    HeaderSearchForm,
    HeroImage,
  },
  mixins: [DeviceHelper],
  props: {
    claimtop: {
      type: Boolean,
      default: false,
    },
    multiHeadline: {
      type: Boolean,
      default: true,
    },
    onlyFillStore: {
      type: Boolean,
      default: false,
    },
    hideHeadSearch: {
      type: Boolean,
      default: false,
    },
    hideTrustElements: {
      type: Boolean,
      default: false,
    },
    headerSearchCountry: {
      type: String,
      default: '',
    },
    headerSearchRegion: {
      type: [String, Number],
      default: '',
    },
    headerSearchQuery: { // object with additional query parameters for search submit
      type: Object,
      default: () => {},
    },
    headerSearchTitle: {
      type: String,
      default: '',
    },
    headerSearchTitleHtml: {
      type: String,
      default: '',
    },
    locationTitle: {
      type: Object,
      default: () => {},
    },
    headerSearchSubtitle: {
      type: String,
      default: '',
    },
    headerSearchBackground: {
      type: String,
      default: '',
    },
    randomImages: {
      type: Array,
      default: () => [],
    },
    offerId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      showPagination: false,
      inviewport: false,
      dontResetPage: this.dontResetPageParam,
      searchTerms: {},
      mapReady: false,
      backgroundImage: this.$store.state.ssr.headerSearchBgImage,
      backgroundImageAlt: this.$store.state.ssr.headerSearchBgImageAlt,
      backgroundImages: config.heroImages.backgroundImages,
      backgroundImagesCountry: config.heroImages.backgroundImagesCountry,
      backgroundImagesRegion: config.heroImages.backgroundImagesRegion,
      backgroundImagesPath: config.heroImages.backgroundImagesPath,
      searchModalReady: false,
      overgreyed: false,
    };
  },
  computed: {
    subTitleClass() {
      if (this.claimtop) {
        return 'h2';
      }
      return 'h1';
    },
    claimClass() {
      if (this.claimtop) {
        return 'h1';
      }
      return 'h2';
    },
    altsArray() {
      return [
        ['search:headerSearch.holidayHomeAndFlatBooking', { preposition: this.locationTitle.titlePrepo }],
        ['search:headerSearchholidayHomeOrFlatRenting', { preposition: this.locationTitle.titlePrepo }],
        ['search:headerSearchbookVacationsHolidayHome', { preposition: this.locationTitle.titlePrepo }],
        ['search:headerSearchaccomodations', { preposition: this.locationTitle.titlePrepo }],
        ['search:headerSearchbookHolidayHouse', { preposition: this.locationTitle.titlePrepo }],
        ['search:headerSearchbookHolidayFlat', { preposition: this.locationTitle.titlePrepo }],
        ['search:headerSearchholidayHomeAndHolidayFlat', { title: this.locationTitle.title }],
        ['search:headerSearchholidayHomesAndHolidayFlats', { title: this.locationTitle.title }],
        ['search:headerSearchtitleAccomodations', { title: this.locationTitle.title }],
      ];
    },
    bgImageAltText() {
      if (typeof this.backgroundImageAlt === 'string') {
        return this.backgroundImageAlt;
      }
      if (this.backgroundImageAlt[0] && this.backgroundImageAlt[1]) {
        return this.$t(this.backgroundImageAlt[0], this.backgroundImageAlt[1]);
      }
      return '';
    },
    locationBreadcrumbs() {
      return this.getLocationBreadcrumbs();
    },
    locationSuccessfull() {
      return this.getLocationSuccessfull();
    },
    linkedOffer() {
      const offerContent = this.$store.getters.getOfferContent(this.offerId);
      return offerContent?.query?.linkedOffer;
    },
  },
  watch: {
    $route: 'setBackground',
    locationSuccessfull: 'setBackground',
  },
  created() {
    this.setBackground(false);
  },
  methods: {
    ...mapGetters(['getLocationBreadcrumbs', 'getLocationSuccessfull']),
    ...mapMutations({ setSearchFilter: 'SET_SEARCHFILTER' }),
    setBackgroundAlt() {
      let backgroundImageAltTmp = '';

      // get image from ssr rendering
      console.log(this.$store.state.app.isNode);
      if (this.$store.state.ssr.headerSearchBgImageAlt !== null && !this.$store.state.app.isNode) {
        backgroundImageAltTmp = this.$store.state.ssr.headerSearchBgImageAlt;
        this.$store.state.ssr.headerSearchBgImageAlt = null;
      } else if (this.headerSearchTitle) {
        backgroundImageAltTmp = this.headerSearchTitle;
      } else if (this.headerSearchSubtitle) {
        backgroundImageAltTmp = this.headerSearchSubtitle;
      } else if (this.locationTitle?.titlePrepo && this.locationTitle?.title) {
        backgroundImageAltTmp = this.altsArray[Math.floor(Math.random() * 9)];
      } else {
        backgroundImageAltTmp = '';
      }

      if (this.backgroundImageAlt !== backgroundImageAltTmp) {
        this.backgroundImageAlt = backgroundImageAltTmp;
        if (this.$store.state.app.isNode) {
          this.$store.state.ssr.backgroundImageAlt = backgroundImageAltTmp;
        }
      }
    },
    setBackground() {
      this.setBackgroundAlt(); // also process background
      let backgroundImageTmp = '';

      // get image from ssr rendering
      if (this.$store.state.ssr.headerSearchBgImage !== null && !this.$store.state.app.isNode) {
        backgroundImageTmp = this.$store.state.ssr.headerSearchBgImage;
        this.$store.state.ssr.headerSearchBgImage = null;
      // specific background image given via prop
      } else if (this.headerSearchBackground) {
        backgroundImageTmp = this.headerSearchBackground;

      // background images array given via prop
      } else if (this.randomImages.length) {
        const idx = Math.floor(Math.random() * this.randomImages.length);
        backgroundImageTmp = this.randomImages[idx];

      // check if images array has offerID
      } else if (this.offerId && this.backgroundImagesPath.find((x) => parseInt(x.offerID, 10) === parseInt(this.offerId, 10))) {
        backgroundImageTmp = this.backgroundImagesPath.find((x) => parseInt(x.offerID, 10) === parseInt(this.offerId, 10)).img;

      // some offers have linked/parent offer. like ski -> ski bayern
      } else if (this.linkedOffer && this.backgroundImagesPath.find((x) => parseInt(x.offerID, 10) === parseInt(this.linkedOffer, 10))) {
        backgroundImageTmp = this.backgroundImagesPath.find((x) => parseInt(x.offerID, 10) === parseInt(this.linkedOffer, 10)).img;

      // image-url exists in background image array by path
      } else if (this.backgroundImagesPath.find((x) => x.path === this.$route.path.replace(/\/$/, ''))) {
        backgroundImageTmp = this.backgroundImagesPath.find((x) => x.path === this.$route.path.replace(/\/$/, '')).img;

      // check this.locationSuccessfull to prevent duplicate background loading
      } else if (this.locationSuccessfull) {
        // image exists in background image array by country_regionID
        if (this.backgroundImagesRegion[`${this.headerSearchCountry}_${this.headerSearchRegion}`]) {
          backgroundImageTmp = this.backgroundImagesRegion[`${this.headerSearchCountry}_${this.headerSearchRegion}`];

        // check background image array by breadcrumb entries from smallest to largest
        } else if (this.locationBreadcrumbs.length) {
          // reverse loop through array
          for (let i = this.locationBreadcrumbs.length - 1; i > -1; i -= 1) {
            if (this.backgroundImagesRegion[`${this.headerSearchCountry}_${this.locationBreadcrumbs[i].regionID}`]) {
              backgroundImageTmp = this.backgroundImagesRegion[`${this.headerSearchCountry}_${this.locationBreadcrumbs[i].regionID}`];
              // exit loop if background from breadcrumb found
              i = -1;
            }
          }
        }

        // fallback to country background
        if (!backgroundImageTmp && this.backgroundImagesCountry[`${this.headerSearchCountry}`]) {
          backgroundImageTmp = this.backgroundImagesCountry[`${this.headerSearchCountry}`];
        }

        // if still no background found -> set random background image from background image array
        if (!backgroundImageTmp) {
          const idx = Math.floor(Math.random() * this.backgroundImages.length);
          backgroundImageTmp = this.backgroundImages[idx];
        }
      }

      if (backgroundImageTmp && this.backgroundImage !== backgroundImageTmp) {
        this.backgroundImage = backgroundImageTmp;
        if (this.$store.state.app.isNode) this.$store.state.ssr.headerSearchBgImage = backgroundImageTmp;
      }
    },
  },
};
</script>

<style lang="scss" src="@/scss/components/search/HeaderSearch.scss" scoped clientextend></style>

<style lang="scss" src="@/clients/wlv/scss/components/search/HeaderSearchAdditional.scss" scoped clientextend></style>